import { createAction } from '@reduxjs/toolkit';

/**
 * Dispatched by the "Recompute Placement" control to trigger the garment-placement saga
 * in `documents/saga.ts`. Gathers the document's `garmentPlacement` inputs, current landmark
 * markers, decoration specs, and size chart data, then calculates and applies updated placement
 * points via `recomputeGarmentPlacement`.
 *
 * This is an action trigger only (no state reducer); the resulting `recomputeGarmentPlacement`
 * dispatch updates document state.
 */
export const requestGarmentPlacementRecompute = createAction<{ id: string }>(
    'documents/requestGarmentPlacementRecompute',
);
